;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { cn } from '@workspace/ui/lib';
import type { ReactNode } from 'react';

interface AppCenteredStatusProps {
  icon: ReactNode;
  title: string;
  description: string;
  actions?: ReactNode;
  /** Full-viewport grey canvas for screens that sit outside the app layout. */
  fillViewport?: boolean;
  children?: ReactNode;
}

export function AppCenteredStatus({
  icon,
  title,
  description,
  actions,
  fillViewport = false,
  children,
}: AppCenteredStatusProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center px-5',
        fillViewport ? 'bg-grey-50 dark:bg-grey-1100 min-h-screen' : 'min-h-[calc(100dvh-12rem)]'
      )}
    >
      <div className="flex w-full max-w-[600px] flex-col items-center gap-7 p-11 text-center">
        {icon}

        <p className="text-neutral-200 text-[32px] leading-10 font-semibold dark:text-neutral-100">
          {title}
        </p>

        <p className="text-grey-600 dark:text-grey-400 text-sm leading-5 font-normal">
          {description}
        </p>

        {actions}
      </div>
      {children}
    </div>
  );
}
